import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { NGXLogger } from "ngx-logger";
import { from } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private logger: NGXLogger) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next))
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    this.logger.trace('AuthInterceptor (angular app)');
    let editCustomerKey = window.localStorage.getItem('puzzel_editCustomerKey');
    let editAsUserId = window.sessionStorage.getItem('puzzel_editAsUserId');
    let config = JSON.parse(window.localStorage.getItem('puzzel_config'));
    let customerCategory = config.custC ?? "";
    let authToken: string;
    let retryCounter = 0;
    do {
      authToken = window.localStorage.getItem('puzzel_token') || '';
      try {
        let payload: any = jwtDecode(authToken);
        if (payload && (payload.exp * 1000 > (Date.now() + 5000))) {
          break;
        }
      } catch (error) {
        this.logger.warn(error);
      }

      this.logger.trace("Token expired. Waiting for new");
      await new Promise(resolve => setTimeout(resolve, 500));
    } while (++retryCounter < 10);

    let headers = req.headers.set('Authorization', 'Bearer ' + authToken).set('X-EditCustomerKey', editCustomerKey).set("X-CustomerCategory", customerCategory);

    if (editAsUserId != null) {
      headers = headers.set('X-EditAsUserId', editAsUserId);
    }

    const authReq = req.clone({
      headers: headers
    });

    return next.handle(authReq).toPromise();
  }
}
